'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function ($stateProvider) {
  'ngInject';

  $stateProvider.state('update', {
    url: '/update',
    template: '<update></update>'
  }).state('update.edit', {
    url: '/edit/:id',
    template: require('./form/form.pug'),
    controller: 'UpdateFormController',
    controllerAs: '$update',
    authenticate: true,
    resolve: {
      update: function update(Updates, $stateParams) {
        return Updates.query({ _id: $stateParams.id });
      }
    }
  }).state('update.new', {
    url: '/new',
    template: require('./form/form.pug'),
    controller: 'UpdateFormController',
    controllerAs: '$update',
    authenticate: true,
    resolve: {
      update: function update() {
        return null;
      }
    }
  }).state('update.list', {
    url: '/list',
    template: require('./list/list.pug'),
    controller: 'UpdateListController',
    controllerAs: '$update',
    authenticate: true,
    resolve: {
      list: function list(Updates) {
        return Updates.query();
      }
    }
  });
};


// WEBPACK FOOTER //
// ./client/app/update/update.routes.js